import React from 'react'

import { Field } from 'formik'

import { H5 } from '@driftt/tide-core'

import useIntegrations from '../../../hooks/useIntegrations'
import C from '../constants'
import CheckboxRow from '../form/CheckboxRow'
import LoadingFieldRow from '../form/LoadingFieldRow'
import MultiSelectCheckboxRow from '../form/MultiSelectCheckboxRow'

interface Props {
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void
}

const AdministratorSection: React.FC<Props> = ({ setFieldValue }) => {
  const { loadingIntegrations, integrationsFailed, fetchIntegrations } = useIntegrations(
    setFieldValue
  )
  return (
    <section>
      <H5>Administrator emails</H5>
      <Field name="properties.dailyAdminEmail">
        {(props: any) => (
          <CheckboxRow
            {...props}
            content="Every morning with team stats, action items and how Drift is performing for you"
          />
        )}
      </Field>

      <Field name="properties.historicalPerformanceEmail">
        {(props: any) => (
          <CheckboxRow
            {...props}
            content="When a playbook suddenly stops sending to site visitors"
          />
        )}
      </Field>

      <Field name="properties.disableNewTeammateEmails">
        {(props: any) => (
          <CheckboxRow {...props} content="When a teammate is added to your organization" inverse />
        )}
      </Field>

      <Field name="properties.adminIntegrationToggleNotification">
        {(props: any) => (
          <CheckboxRow
            {...props}
            content="When an integration is connected or disconnected to Drift"
          />
        )}
      </Field>
      <Field name="integrationSettings.topLevelFirstErrorEnabled">
        {({ field: checkBoxField, form, ...rest }: any) => (
          <LoadingFieldRow
            loading={loadingIntegrations}
            failed={integrationsFailed}
            handleRetry={fetchIntegrations}
            label="integrations">
            <MultiSelectCheckboxRow
              {...rest}
              label="When the first sync error of the day occurs for the selected integrations"
              selectFieldName="integrationSettings.values"
              onCheckboxChange={() => {
                checkBoxField.value === true &&
                  form.values.integrationSettings.values.length === 0 &&
                  form.setFieldValue(
                    'integrationSettings.values',
                    C.INTEGRATION_OPTIONS.map(o => o.value)
                  )
              }}
              form={form}
              checkBoxField={checkBoxField}
              options={C.INTEGRATION_OPTIONS}
            />
          </LoadingFieldRow>
        )}
      </Field>
    </section>
  )
}

export default AdministratorSection
